/* eslint-disable no-unused-vars */

// import { ready } from 'jquery';
import * as Cookies from 'js-cookie';
// import { debounce } from 'lodash';
// import debounce from 'lodash/debounce';

// import Alpine from "alpinejs";
//import tippy from 'tippy.js';

import {
  slickHP,
  slickArtigos,
  slickCatalogo,
  slickDicas,
  slickDisponiveis,
  slickDisponiveisSearch,
  slickFolhetos,
  slickMarcas,
  slickLogos,
  slickNoticias,
  slickProdutos,
  slickProdutosRecentes,
  slickProdutosRecentesLess,
  slickServicos,
} from '../brico/slick';

// window.Alpine = Alpine;
// Alpine.start();

var request_products;
var request_pages;

const megaMenuItem = (post) => {
  var imageurl = post.imagem
    ? post.imagem
    : '/wp-content/themes/bricomarche/resources/assets/images/noticias_dummy.png';
  var path = post.guid;
  var precoInt = Math.floor(post.preco);
  var centimos = number_format(post.preco - precoInt, 2);
  centimos = centimos.replace(/^0+./, '');
  if (centimos == '00') {
    centimos = '';
  }

  var preco =
    '<div class="price">' +
    precoInt +
    '<sup>€</sup><span class="centimos">' +
    centimos +
    '</div>';
  var marca = post.marca ? `<div class="brand">${post.marca}</div>` : '';

  var pricePerUnit = post['data']['price-per-unit']
    ? '<div class="price-per-unit">' + post['data']['price-per-unit'] + '</div>'
    : '';

  return `<div class="destaque-box col-6">
            <a href="${path}" target="_self">
              <div class="thumb" style="background:url('${imageurl}')no-repeat center center;background-size: contain !important;"></div>
              <div class="content"><div class="texto">
                <div class="title"><h3>${post.post_title}</h3></div>
                ${marca}
                ${preco}
                ${pricePerUnit} 
              </div></div>
            </a>
          </div>`;
};

const updateStore = () => {
  var lojaName = Cookies.get('loja-name');
  $('.localidade span.choise').html(
    lojaName ? lojaName.replace(/\+/g, ' ') : ''
  );

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    method: 'POST',
    data: {
      action: 'get_current_store',
      href: location.href,
    },
    dataType: 'JSON',
    success: function (store) {
      window.currentStore = store;

      if (store && location.pathname.match(/^\/produtos?\//)) {
        location.href = '/' + store.slug + location.pathname;
      }

      $('.localidade span.choise').html(
        store && store.name ? store.name : 'Localidade'
      );
      $('.local a span').html(
        store && store.name ? store.name : 'Escolher Loja'
      );

      // add store to megamenu
      if (store) {
        $('ul.family a, ul.family-child a, ul.prod-categories a').each(
          function () {
            var href = $(this).attr('href');
            if (href.match(/^\/produtos/)) {
              href = '/' + store.slug + href;
              $(this).attr('href', href);
            }
          }
        );
      }

      if (store.click_collect) {
        $('.nav-item-cart').show();
      }

      if (
        store &&
        store.slug &&
        $('body').hasClass('single-product') &&
        $('#pa_loja').val() !== store.slug
      ) {
        if ($('div.label-folheto').length) {
          $('#pa_loja').val('master').trigger('change');
        } else {
          $('#pa_loja').val(store.slug).trigger('change');
        }
      }

      // add to cart only for stores with click & collect
      if (store && $('body').hasClass('single-product')) {
        if (store.click_collect) {
          $('.brico-add-to-cart').css({ opacity: 1 });
        } else {
          $('.brico-add-to-cart').fadeOut();
        }
      }

      // Enable "add to cart" in /a-minha-lista/
      if (store && $('body').hasClass('a-minha-lista')) {
        if (store.click_collect) {
          $('.product-action').addClass('active');
        }
      }

      if (store && !store.click_collect && $('body').hasClass('carrinho')) {
        location.href = '/a-minha-lista/';
      }

      // Hide cart for stores without click & collect
      if (store && !store.click_collect) {
        $('li.cart').fadeOut();
        $('.sidebyside .cart').fadeOut();
      }
    },
  });
};

const onChangeStore = () => {
  $('body').on('click', '.cookieset', function (e) {
    e.preventDefault();

    $('#location-loading').fadeIn();

    var data = {
      slug: $(this).data('slug'),
      action: 'change_store',
    };

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      data: data,
      dataType: 'JSON',
      success: function (data) {
        var store = Cookies.get('loja-slug');

        // console.log(store , location.pathname , data.url);
        var path = location.pathname;
        if (window.location.href.indexOf('produto') != -1) {
          path = '/' + path.replace(/^\/.[^/]+\//g, '');
        }

        window.location.href = path; // data.url
      },
    });
  });
};

var currentFilterRequest = null;
var filtersRequest = {};

function number_format(number, decimals, dec_point, thousands_sep) {
  // Strip all characters but numerical ones.
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.round(n * k) / k;
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}
/*ORDER PROD*/
$('.brico-products-container .dropsearch .dropdown-menu a').on(
  'click',
  function (e) {
    e.preventDefault();
    var ordernacao = $(this).attr('data-order');

    if (ordernacao == 'asc') {
      $('.brico-products-container .dropsearch button span').html(
        'Ordenação alfabética: A - Z'
      );
      $('.frm-sidebar').find('input[name="orderby"]').val('post_name');
      $('.frm-sidebar').find('input[name="order"]').val('asc');
    } else if (ordernacao == 'desc') {
      $('.brico-products-container .dropsearch button span').html(
        'Ordenação alfabética: Z - A'
      );
      $('.frm-sidebar').find('input[name="orderby"]').val('post_name');
      $('.frm-sidebar').find('input[name="order"]').val('desc');
    } else if (ordernacao == 'price_asc') {
      $('.brico-products-container .dropsearch button span').html(
        'Preço Ascendente'
      );
      $('.frm-sidebar').find('input[name="orderby"]').val('price');
      $('.frm-sidebar').find('input[name="order"]').val('asc');
    } else if (ordernacao == 'price_desc') {
      $('.brico-products-container .dropsearch button span').html('Preço Descendente');
      $('.frm-sidebar').find('input[name="orderby"]').val('price');
      $('.frm-sidebar').find('input[name="order"]').val('desc');
    }

    // $('.frm-sidebar').find('input[name="order"]').val(ordernacao);

    currentFilterRequest = $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      data: $('.frm-sidebar').serialize(),
      beforeSend: function () {
        $('.brico-products-container').addClass('loading');
        $('html, body').animate({ scrollTop: 0 });
        $('.frm-sidebar input[name="page"]').val(1);
        if (currentFilterRequest != null) {
          currentFilterRequest.abort();
        }
      },
      success: function (data) {
        $('#brico-products').html(data.products);
        $('.brico-products-container').removeClass('loading');

        if (data.filter === 'tag' || data.filter === '') {
          $('div.filter-group-brand ul.filters').html(data.filter_brand);
        }

        if (data.filter === 'brand' || data.filter === '') {
          $('div.filter-group-tag ul.filters').html(data.filter_tag);
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr.status);
        console.log(xhr.responseText);
        console.log(thrownError);
      },
    });
  }
);

/**
 * Filter Products (Sidebar)
 */
const frmProductFilters = () => {
  const frm = $('.frm-sidebar');

  $(frm).on('submit', function (e) {
    e.preventDefault();

    currentFilterRequest = $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      data: $(this).serialize(),
      beforeSend: function () {
        $('.brico-products-container').addClass('loading');
        $('html, body').animate({ scrollTop: 0 });
        $('.frm-sidebar input[name="page"]').val(1);
        if (currentFilterRequest != null) {
          currentFilterRequest.abort();
        }
      },
      success: function (data) {
        $('#brico-products').html(data.products);
        $('.brico-products-container').removeClass('loading');

        if (data.filter === 'tag' || data.filter === '') {
          $('div.filter-group-brand ul.filters').html(data.filter_brand);
        }

        if (data.filter === 'brand' || data.filter === '') {
          $('div.filter-group-tag ul.filters').html(data.filter_tag);
        }
      },
    });
  });

  $(frm)
    .find('button.reset')
    .on('click', function (e) {
      e.preventDefault();
      $(frm).find('input[name="page"]').val(1);

      $('.filter-group').trigger('filters:reset');
      $(frm).trigger('reset').trigger('submit');
    });
  $(frm)
    .find('a.reset')
    .on('click', function (e) {
      e.preventDefault();
      $(frm).find('input[name="page"]').val(1);

      $('.filter-group').trigger('filters:reset');
      $(frm).trigger('reset').trigger('submit');
    });

  $('.filter-group').on('filters:reset', function () {
    $(this).find('ul.filters li').show();
    $(this)
      .find('ul.filters li span')
      .each(function () {
        $(this).html('(' + $(this).data('count') + ')');
      });
  });

  // $('.filter-group').on('filters:update', function () {
  //   console.log('filters:update');
  // });

  $('.filter-group').on('filters:update-old', function () {
    var group = $(this);
    var group_id = $(this).data('filter');

    // Update Filters
    $(frm).find('input[name="action"]').val('brico_update_filters');
    $(frm).find('input[name="filter"]').val($(this).data('filter'));
    filtersRequest[group_id] = $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      data: $(frm).serialize(),
      // dataType: 'json',
      beforeSend: function () {
        $(group).addClass('loading');
        if (filtersRequest[group_id] != null) {
          filtersRequest[group_id].abort();
        }
      },
      success: function (data) {
        $(group).find('ul.filters').html(data);
        $(group).toggle(data != '');

        /*
        $(group).find('ul.filters li').hide();

        $.each(data, function (n, el) {
          $(group).find('ul.filters li.term-' + el.term_id).show();
          $(group).find('ul.filters li.term-' + el.term_id + ' span').html('(' + el.count + ')');
        });
        */

        $(group).removeClass('loading');
      },
    });
    $(frm).find('input[name="action"]').val('brico_filter_products');
    $(frm).find('input[name="filter"]').val('');
  });

  $('.frm-sidebar').on('change', 'input[type="checkbox"]', function () {
    var group = $('.filter-group').not(
      '.filter-group-' + $(this).data('filter')
    );

    $(frm).find('[name="filter"]').val($(this).data('filter'));

    // Submit Form
    $(frm).trigger('submit');

    // Update filters
    $(group).trigger('filters:update');
  });

  $('#brico-products').on('click', 'ul.page-numbers a', function (e) {
    e.preventDefault();

    var m = $(this)
      .attr('href')
      .match(/page\/(\d+)\//);
    if (m) {
      $('.frm-sidebar input[name="page"]').val(m[1]);
    }

    $(frm).trigger('submit');
  });

  $('.frm-sidebar').on('click', '.ver-mais a', function (e) {
    e.preventDefault();
    $(this).closest('.filter-group').find('ul.filters').toggleClass('limit');
    $(this).toggleClass('menos');
  });
};

const onChangeFamily = () => {
  $('div.div-familia').on(
    'click',
    'ul.family a, ul.family-child a',
    function (e) {
      if (!$('body').hasClass('post-type-archive-product')) {
        return;
      }

      e.preventDefault();

      // Unckeck filters
      $('.frm-sidebar [type="checkbox"]').prop('checked', false);

      // console.log('update family/subfamily');
      $('.frm-sidebar input[name=family]').val($(this).data('family'));
      $('.frm-sidebar input[name=subfamily]').val($(this).data('subfamily'));
      $('.frm-sidebar input[name=page]').val(1);
      $('.frm-sidebar input[name=base]').val($(this).attr('href'));
      $('.frm-sidebar input[name=filter]').val('');

      window.history.replaceState({}, '', $(this).attr('href'));
      // console.log( $(this).attr('href') );

      $('.main-categoria').html($(this).html());

      // Update breadcrumb
      let breadcrumb = [];
      breadcrumb.push('<a href="/">Bricomarché</a>');
      breadcrumb.push(
        window.currentStore
          ? '<a href="/' + window.currentStore.slug + '/produtos/">Produtos</a>'
          : '<a href="/produtos/">Produtos</a>'
      );

      if ($(this).parent().parent().is('ul.family-child')) {
        breadcrumb.push(
          '<a href="' +
            $(this)
              .attr('href')
              .replace(/[\w-]+\/$/, '') +
            '">' +
            $(this).data('familyName') +
            '</a>'
        );
      }

      breadcrumb.push(
        '<a href="' + $(this).attr('href') + '">' + $(this).text() + '</a>'
      );

      var lastcat = $(this).text();

      breadcrumb = breadcrumb.join(' > ');
      breadcrumb = '<span><span>' + breadcrumb + '</span></span>';
      $('div.breadcrumbs').html(breadcrumb);

      $('.frm-sidebar').trigger('submit');
      $('.filter-group').trigger('filters:update');

      $('.megamenu').addClass('d-none');

      // Update Category IMAGE
      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html', // add data type
        type: 'POST',
        data: {
          action: 'get_ajax_category',
          href: location.href,
        },
        success: function (cat_response) {
          $('.main-categoria').html(lastcat);
          $('.category-header').html('');
          $('.category-header').html(
            '<img src="' + cat_response + '" class="img-fluid" />'
          );
        },
      });
    }
  );
};

const loadProdutosEmDestaque = () => {
  if (!$('#produtos-em-destaque').length) {
    return;
  }

  $.post(
    '/wp-admin/admin-ajax.php',
    { action: 'produtos_em_destaque' },
    function (response) {
      $('#produtos-em-destaque').removeClass('loading').html(response);

      var contador = $('.slick-produtos-mais-recentes .wrap').length;
      if (contador >= 8) {
        $('.slick-produtos-mais-recentes').slick(slickProdutosRecentes);
      } else {
        $('.slick-produtos-mais-recentes').slick(slickProdutosRecentesLess);
      }
    }
  );
};

function ajaxSearchProducts(searchKey) {
  var cookie = Cookies.get('loja-slug');
  var dataLayer;
  if (request_products) {
    request_products.abort();
  }
  request_products = $.ajax({
    type: 'get',
    url:
      '/wp-json/wp/v2/search_product_menu/?s=' +
      searchKey +
      '&cookie=' +
      cookie,
  }).done(function (data) {
    /// GA4 PUSH
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'search',
      searchTerm: searchKey, //this should be dynamically replaced with an actual search query
    });
    /// END GA4

    $('.showresults .prod-list ul').html('');
    $('.showresults').removeClass('d-none');
    $.each(data, function () {
      const thumb =
        this.thumbnail ||
        '/wp-content/themes/bricomarche/resources/assets/images/dummy.png';
      const family = this.familia.name || this.familia || '';
      $('.showresults .prod-list ul').append(
        '<li class="row"><div class="col-3 col-thumb"><img src="' +
          thumb +
          '" class="img-fluid"></div><div class="col-9"><a href="' +
          this.permalink +
          '" target="_self">' +
          this.name +
          '<span>' +
          family +
          '</span></a></div></li>'
      );
    });
    if (data == null) {
      $('.showresults .prod-list ul').append(
        '<li class="row"><i>Não foram encontrados resultados.</i></li>'
      );
    }

    request_products = null;
  });
}

function ajaxSearchPages(searchKey) {
  var cookie = Cookies.get('loja-slug');
  if (request_pages) {
    request_pages.abort();
  }
  request_pages = $.ajax({
    type: 'get',
    url:
      '/wp-json/wp/v2/search_pages_menu/?s=' + searchKey + '&cookie=' + cookie,
  }).done(function (data) {
    $('.showresults .pag-list ul').html('');
    $('.showresults').removeClass('d-none');
    $.each(data, function () {
      $('.showresults .pag-list ul').append(
        '<li class="row"><a href="' +
          this.guid +
          '" target="_self">' +
          this.post_title +
          '</a></li>'
      );
    });
    if (data == '') {
      $('.showresults .pag-list ul').append(
        '<li class="row"><i>Não foram encontrados resultados.</i></li>'
      );
    }

    request_pages = null;
  });
}

const setupSearch = () => {
  var cookie = Cookies.get('loja-slug');

  //MOBILE
  if (!cookie) {
    $('.navbar-collapse .search-form').addClass('d-none');
    $('.navbar-collapse .no-store-mobile').removeClass('d-none');
  }

  //DESKTOP check searchform.php
  // $('.search-field').unbind('keyup').unbind('click').bind('click keyup', function (e) {
  $('.search-field').on('keyup', function (e) {
    var dInput = this.value;
    if (dInput.length < 3) return;


    $('.ver-todos').attr('href', '/?s=' + dInput);

    if (cookie) {
      ajaxSearchProducts(dInput);
      ajaxSearchPages(dInput);
      $('.search-submit').removeClass('pointer-event-none');
    } else {
      $('.no-store').removeClass('d-none');
    }
  });

  $(document).keypress(function (e) {
    if (!cookie && e.which == 13) {
      e.preventDefault();
    }
  });

  $(document).on('click', function (e) {
    if ($('.showresults').hasClass('.d-none') == false) {
      $('.showresults').addClass('d-none');
    }
  });

  $('.navbar-toggler').on('click', function () {
    $('body').toggleClass('overflow-hidden');
    $('.burger').toggleClass('d-none');
    $('svg.close').toggleClass('d-none');
  });
};

export default {
  init() {
    loadProdutosEmDestaque();
    updateStore();
    onChangeStore();
    frmProductFilters();
    onChangeFamily();
    setupSearch();

    // Browser back to categories
    if (
      $('body').hasClass('post-type-archive-product') &&
      $('.frm-sidebar').find(':checked').length
    ) {
      $('.frm-sidebar').trigger('submit');
    }

    // Cofidis Pay
    $('.btn-cofidis-pay').on('click', function (e) {
      e.preventDefault();
      $('.cofidis-modal-overlay').css('display', 'flex').hide().fadeIn();
    });

    $('.cofidis-modal-overlay-close').on('click', function (e) {
      e.preventDefault();
      $('.cofidis-modal-overlay').fadeOut();
    });

    // Seleciona o botão e o modal
    const $infoButton = $('.cofidis-extra-info');
    const $modalOverlay = $('.cofidis-info-modal-overlay');
    const $modal = $('.cofidis-modal-info');

    // Função para abrir o modal centralizado na tela
    $infoButton.on('click', function () {
      // Exibe o modal e o overlay
      $modalOverlay.show();
      $modal.css({
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      });
    });

    // Fecha o modal ao clicar no botão de fechar
    $modalOverlay.on('click', function () {
      $modalOverlay.hide();
    });

    /*
    if($('.slick-produtos-mais-recentes').length){
      var store = Cookies.get('loja-slug');
      if(store){
        $('.slick-produtos-mais-recentes a').each(function(){
          var cat = $(this).attr('data-cat');
          var subcat = $(this).attr('data-subat');
          var link = $(this).attr('href');
          if(link.indexOf(cat) > -1){
            $(this).attr('href', href); 
          }else{
            var href = $(this).attr('href').replace(/\/produto\//, `/${store}/produto/${cat}/${subcat}/`);
            $(this).attr('href', href);
          }
        });
      }
      
    }*/
  },

  finalize() {
    // Hide Header on on scroll down
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = $('#site-header');
    var megamenu = $('.megamenu');

    var checkScroll = function () {
      curScroll = w.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) {
        //scrolled up
        direction = 2;
      } else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }

      prevScroll = curScroll;
    };

    jQuery.ajax({
      url: '/wp-admin/admin-ajax.php',
      dataType: 'html', // add data type
      type: 'POST',
      data: { action: 'get_ajax_slides' },
      success: function (response) {
        $('#sliderHP .sliderhp').html(response);
        $('.sliderhp').slick(slickHP);
      },
    });

    var toggleHeader = function (direction, curScroll) {
      if (direction === 2 && curScroll > 152) {
        //replace 52 with the height of your header in px

        header.addClass('hide');
        prevDirection = direction;
      } else if (direction === 1) {
        header.removeClass('hide');
        prevDirection = direction;
      }
    };

    window.addEventListener('scroll', checkScroll);

    //OPEN
    $('li.showP').on('click', function (e) {
      e.preventDefault();
      $('.megamenu').removeClass('d-none');

      window.scrollTo({
        top: HTMLBodyElement,
        left: 0,
        behavior: 'smooth',
      });
    });
    //CLOSE
    $('.closemenu').on('click', function () {
      $('.megamenu').toggleClass('d-none');
    });

    $('.megamenu-bg').on('click', function () {
      $('.megamenu').addClass('d-none');
    });

    // Megamenu
    var loja_slug = Cookies.get('loja-slug') || 'empty';
    $.getJSON(
      '/wp-json/brico/v1/destaques-megamenu/' + loja_slug,
      function (data) {
        window.destaqueMegamenu = data;
      }
    );

    $('.menu-produtos ul.family>li>a').hover(function (e) {
      e.preventDefault();
      $('.menu-produtos .destaques .box').empty();

      var familyID = $(this).data('id');
      $('.menu-produtos ul.family>li>a').removeClass('active');
      $(this).addClass('active');

      $('.div-sub-family').addClass('d-none');
      $('.div-sub-family-' + familyID).removeClass('d-none');

      var data = window.destaqueMegamenu['destaques-' + familyID];
      if (data) {
        $.each(data, function (n, el) {
          //console.log(el);
          if (el.preco) {
            $('.menu-produtos .destaques .box').append(megaMenuItem(el));
          }
        });
      }

      $('.destaques .destaque-box a').each(function () {
        var href = $(this).attr('href');
        var store = Cookies.get('loja-slug');
        //console.log(href);
        //console.log(href.match(/produto/));
        // if(href.match(/produto/)){

        //   href = '/'+store +'/'+ href;
        //   //console.log(href);
        //   $(this).attr('href', href);

        // }
      });
    });

    $('.menu-produtos ul.family-child li a').hover(function (e) {
      e.preventDefault();
      $('.menu-produtos .destaques .box').empty();

      $('.menu-produtos ul.family-child li a').removeClass('active');
      $(this).addClass('active');

      var familyID = $(this).data('id');
      var data = window.destaqueMegamenu['destaques-' + familyID];
      if (data) {
        $.each(data, function (n, el) {
          if (el.preco) {
            $('.menu-produtos .destaques .box').append(megaMenuItem(el));
          }
        });
      }
      $('.destaques .destaque-box a').each(function () {
        var href = $(this).attr('href');
        var store = Cookies.get('loja-slug');
        //console.log(href);
        //console.log(href.match(/produto/));x
        // if(href.match(/produto/)){

        //   href = '/'+store +'/'+ href;
        //   // console.log(href);
        //   $(this).attr('href', href);

        // }
      });
    });

    $('.back a').on('click', function (e) {
      e.preventDefault();
      window.scrollTo(0, 0);

      if (location.pathname.match(/^\/produtos/)) {
        $('#locations').removeClass('close');
        return;
      }

      $('.no-store').addClass('d-none');
      $('#locations').toggleClass('close');
      $('body').toggleClass('noscroll');
    });
    // MAPA
    $('.localidade a').on('click', function (e) {
      e.preventDefault();
      window.scrollTo(0, 0);

      if (location.pathname.match(/^\/produtos/)) {
        $('#locations').removeClass('close');
        return;
      }

      $('.no-store').addClass('d-none');
      $('#locations').toggleClass('close');
      $('body').toggleClass('noscroll');
    });

    $('.local a').on('click', function (e) {
      e.preventDefault();

      window.scrollTo(0, 0);

      if (location.pathname.match(/^\/produtos/)) {
        $('#locations').removeClass('close');
        return;
      }

      $('#locations').toggleClass('close');
      $('body').toggleClass('noscroll');
    });
    $('#lojas .close').on('click', function () {
      $('#locations').toggleClass('close');
      $('body').toggleClass('noscroll');
    });

    /**
     * Change Distrito
     */
    $('select.distrito').on('change', function () {
      var distritID = this.value;
      const lojas_distrito = window.lojas.filter(
        (loja) => loja.district_id == distritID
      );

      //$('select.concelho').val('0').trigger('change');
      if ($('select.distrito').val() == '0') {
        $('select.concelho option').attr('hidden', false);
      }

      if ($('select.distrito').val() == '0') {
        $('select.concelho').selectpicker('destroy');
        $('select.concelho').selectpicker();

        $('div.concelho div.filter-option-inner-inner').html(
          'Selecionar Concelho'
        );
      }

      $('.loja-cookies .content').empty();
      $('select.concelho').removeAttr('disabled');

      if ($('select.distrito').val() != '') {
        $('select.concelho option').attr('hidden', true);
      }

      $('select.concelho option[value="0"]').attr('hidden', false);
      $('select.concelho').val('0');

      $.each(lojas_distrito, function () {
        var value = this['concelho_id'];
        $('select.concelho option[value="' + value + '"]').attr(
          'hidden',
          false
        );

        var slug = this.slug;
        var name = this.name;
        var id = this.id;
        var lat = this.lat;
        var log = this.lng;
        var click_collect = this['click_&_collect'];

        $('.loja-cookies .content').append(
          '<a class="cookieset mb-2 btn-saber-mais text-lg font-semibold mr-2" data-click="' +
            click_collect +
            '" data-name="' +
            name +
            '" data-slug="' +
            slug +
            '" data-id="' +
            id +
            '" href="#">' +
            name +
            '</a>'
        );

        $('select.concelho').selectpicker('destroy');
        $('select.concelho').selectpicker();
      });
    });

    /**
     * Change Concelho
     */
    $('select.concelho').on('change', function () {
      var concelhoID = this.value;
      const lojas_concelho = window.lojas.filter(
        (loja) => loja.concelho_id == concelhoID
      );

      $('.loja-cookies .content').empty();
      if (lojas_concelho.length == 0) {
        $('.loja-cookies .content').append(
          'Por favor escolha outro concelho, de momento não temos nenhum loja na area selecionada.'
        );
      }

      $.each(lojas_concelho, function () {
        var id = this.id;
        var name = this.name;
        var slug = this.slug;

        var lat = this.lat;
        var log = this.lng;
        var click_collect = this['click_&_collect'];

        $('select.concelho').removeAttr('disabled');

        $('.loja-cookies .content').append(
          '<a class="cookieset mb-2 btn-saber-mais text-lg font-semibold mr-2" data-click="' +
            click_collect +
            '" data-name="' +
            name +
            '" data-slug="' +
            slug +
            '" data-id="' +
            id +
            '" href="#">' +
            name +
            '</a>'
        );
      });
    });

    //$('.sliderhp').slick(slickHP);
    $('.slick-produtos').slick(slickProdutos);
    $('.slick-disponiveis-search').slick(slickDisponiveisSearch);
    //$('.slick-disponiveis').slick(slickDisponiveis);
    $('.slick-artigos').slick(slickArtigos);
    $('.slick-dicas').slick(slickDicas);
    $('.slick-servicos').slick(slickServicos);
    $('.slick-marcas').slick(slickMarcas);
    $('.slick-noticias').slick(slickNoticias);
    $('.slick-folhetos').slick(slickFolhetos);
    $('.slick-catalogo').slick(slickCatalogo);

    var windowWidth = window.innerWidth;
    console.log(windowWidth);
    if (windowWidth < 767) {
      $('.logos').slick(slickLogos);
    }

    // SELECT BOX

    $('select.distrito').selectpicker();
    $('select.concelho').selectpicker();
    $('select.wpcf7-select').selectpicker();
    $('select.orderby').selectpicker();
    $('select.woof_select_family').selectpicker();
    $('select.woof_mselect_product_tag').selectpicker();

    //$('select').selectpicker();

    // FOOTER

    $('h3.label').on('click', function () {
      $(this).next('.navbar-content').toggle();
    });

    //icon accordion
    // Add down arrow icon for collapse element which is open by default

    // Toggle right and down arrow icon on show hide of collapse element
    $('.collapse')
      .on('show.bs.collapse', function () {
        $(this)
          .prev('.card-header')
          .find('.fa')
          .removeClass('fa-angle-down')
          .addClass('fa-angle-up');
      })
      .on('hide.bs.collapse', function () {
        $(this)
          .prev('.card-header')
          .find('.fa')
          .removeClass('fa-angle-up')
          .addClass('fa-angle-down');
      });

    /*
    // VALIDATION

    // equivalent in css
    .wishlist_products_counter_number:empty{
			display: none;
		}
    */
    setInterval(function () {
      if ($('.wishlist_products_counter_number').html() != 0) {
        $('.heart').removeClass('empty');
      }
    }, 500);

    /**
     * Produtos -> Open
     */
    $('#navbarSupportedContent1 .nav-item.Produtos .nav-link').on(
      'click',
      function (e) {
        e.preventDefault();
        $('.prod-categories').toggleClass('d-none');
        $('.see-all').removeClass('active');
        // console.log('open');
      }
    );

    /**
     * Produtos -> Close
     */
    $('.prod-categories li:first-child').on('click', function (e) {
      e.preventDefault();
      $('.prod-categories').toggleClass('d-none');
      $('.see-all').addClass('active');
      // console.log('close');
    });

    /**
     * First Level
     */
    $('#navbarSupportedContent1 ul.prod-categories>li>a').on(
      'click',
      function (e) {
        if ($(this).next().is('ul') && !$(this).next().find('li').length) {
          $(this).addClass('selected');
          return;
        }

        e.preventDefault();
        $('#navbarSupportedContent1 ul.prod-categories>li>a').removeClass(
          'selected'
        );
        $('#navbarSupportedContent1 ul.prod-categories>li>ul').addClass('none');
        $(this).next().toggleClass('none');

        if (!$(this).next().hasClass('none')) {
          $(this).addClass('selected');
        }
        // console.log('Toggle category');
      }
    );

    /**
     * Second Level
     */
    $('#navbarSupportedContent1 ul.prod-categories>li>ul>li>a').on(
      'click',
      function (e) {
        e.stopPropagation();
      }
    );

    /*
    $('.prod-categories li:first-child').on('click', function () {
      if ($(this).find('span.title').html() == 'Produtos') {
        $('.prod-categories').toggleClass('d-none');
        $('.see-all').removeClass('active');
      } else {
        $('li.first-class span.title').html('Produtos');
        $('.see-all').removeClass('active');
        $('.prod-categories ul.children').addClass('none');
        $('.prod-categories li.pri').removeClass('none');
        $('.prod-categories li.pri a').addClass('link');
      }
    });

    $('#navbarSupportedContent1 ul.prod-categories li.pri a.link').on('click', function (e) {
        if ($(this).hasClass('link')) {
          e.preventDefault();



          $(this).toggleClass('link');
          $('#navbarSupportedContent1 ul.prod-categories li').addClass('none');
          $(this).parent().toggleClass('none');
          $(this).next().toggleClass('none');
          $('li.first-class').toggleClass('none');
          $('li.first-class span.title').html($(this).html());
          $(this).next().find('li').toggleClass('none');

          $('.see-all').addClass('active');
        } else {
          $(this).toggleClass('link');
        }
      }
    );

    $('.prod-categories li:first-child').on('click', function (e) {
      e.preventDefault();
    });

    */

    $('.woocommerce-MyAccount-navigation-link--cartao-bricomarche a').on(
      'click',
      function (e) {
        e.preventDefault();
        window.open(this.href);
      }
    );

    $('.btn-filtro a').on('click', function (e) {
      e.preventDefault();
      $('#filtros').toggleClass('open');
    });
    $('.btn-close').on('click', function (e) {
      e.preventDefault();
      $('#filtros').toggleClass('open');
    });

    $('input[type=password]').attr('minlength', '8');

    $('.woocommerce-form-register .password-input').append(
      '<small class="woocommerce-password-hint">Instruções de password: A password deve ter, no mínimo, 8 caracteres, deve conter uma letra maiúscula e uma letra minúscula e deve conter, no mínimo, um digito de 0-9 e um caracter especial (como ! ” ? $ % ^ & )</small>'
    );

    $('.filtermobile').on('click', function () {
      $('body').toggleClass('oveflow-stop');
      $('#filtros-sidebar').toggleClass('show');
      $('#filter-layer').toggleClass('show');
    });
    $('#filtros-sidebar .close').on('click', function () {
      $('body').toggleClass('oveflow-stop');
      $('#filtros-sidebar').toggleClass('show');
      $('#filter-layer').toggleClass('show');
    });
    $('#filter-layer').on('click', function () {
      $('body').toggleClass('oveflow-stop');
      $('#filtros-sidebar').toggleClass('show');
      $('#filter-layer').toggleClass('show');
    });

    $('.lp-newsletter .lp-newsletter__content form').append(
      $('#optin-newsletter')
    );
  },
};

var $addToCartButton = $('.single_add_to_cart_button');

if ($addToCartButton.length) {
  if (!$addToCartButton.hasClass('bundle_add_to_cart_button')) {  
    $addToCartButton.hide();
    $(document.body).on('found_variation', function () {
      $addToCartButton.fadeIn();
    });
  }
}

$('.cart.bundle_data').append($('.brico-add-to-wishlist'));



jQuery(document).ready(function () {
  const $modalLegislacao = jQuery('#checkoutModal');
  const $modalContent = jQuery('#checkoutModal .checkout-modal');

  jQuery(document).on('click', '#proceedToCheckoutButton', function (e) {
    e.preventDefault();
    const buttonUrl = $(this).attr('href');

    if (buttonUrl !== '#') {
      window.location = buttonUrl;
    } else {
      $('span[class^=error-message]').text('');

      $modalLegislacao
        .css({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        })
        .stop(true, true)
        .fadeIn();

      $('#submit').attr(
        'title',
        'Envie todos os arquivos necessários para desbloquear este botão.'
      );
      $('#submit').prop('disabled', true).css({
        opacity: '0.5',
        cursor: 'not-allowed',
        transition: 'opacity 0.3s ease',
        position: 'relative',
      });
    }
  });

  $(function () {
    function cancelModal() {
      $modalLegislacao.fadeOut();
    }

    $modalLegislacao.on('click', function (e) {
      if (
        !$modalContent.is(e.target) &&
        $modalContent.has(e.target).length === 0
      ) {
        // Chamar a função cancelModal

        cancelModal();
      }
    });

    $(document).on('click', '.cancel-modal', function (e) {
      e.preventDefault();
      cancelModal();
    });
  });
});

$('.checkout-modal-overlay-close').on('click', function (e) {
  e.preventDefault();
  $('#checkoutModal').fadeOut();
});

$('.form-container').on('click', '.custom-file-upload', function (e) {
  e.preventDefault();

  const fileInputId = $(this).data('for');
  $(`#${fileInputId}`).trigger('click');
});

$(document).on('change', '.uploadFileLes', function () {
  const fileInput = $(this);
  const fileLabel = fileInput.siblings('label');
  const icon = fileInput.siblings('.icon_upload');
  const errorId = fileInput.data('error');

  const errorEl = '.error-message-' + errorId;
  const errorMessage = $(errorEl);


  const fileName = fileInput.val().split('\\').pop();
  let fileExtension = getFileExtension(fileName);


  errorMessage.hide().text('');

  if (fileName && fileExtension == '.pdf') {
    const shortFileName = shortenFileName(fileName, 20);
    $('.notification-area').text('');
    fileLabel.text(shortFileName);

    icon.addClass('delete');

    icon.off('click').on('click', function () {
      fileInput.val('');

      fileLabel.text('Carregue o documento');
      icon.removeClass('delete');

      $('#submit').attr(
        'title',
        'Envie todos os arquivos necessários para desbloquear este botão.'
      );
      $('#submit').prop('disabled', true).css({
        opacity: '0.5',
        cursor: 'not-allowed',
        transition: 'opacity 0.3s ease',
        position: 'relative',
      });
    });

    errorMessage.hide().text('');
  } else {
    fileInput.val('');
    errorMessage.text('Por favor, carregue um arquivo no formato PDF.').show();
  }
});

// Ajuste do tamanho do nome
function shortenFileName(fileName, maxLength) {
  const extIndex = fileName.lastIndexOf('.');
  const extension = extIndex !== -1 ? fileName.substring(extIndex) : '';
  const nameWithoutExt =
    extIndex !== -1 ? fileName.substring(0, extIndex) : fileName;

  if (nameWithoutExt.length > maxLength) {
    return `${nameWithoutExt.substring(0, maxLength - 3)}...${extension}`;
  }
  return fileName;
}

$(document).ready(function () {
  const form = $('form');
  const submitButton = $('#submit');

  submitButton.prop('disabled', true);

  form.on('change', '.uploadFileLes', function () {
    const allFilesUploaded = checkAllFileInputs();
    submitButton.prop('disabled', !allFilesUploaded);

    // Atualiza a tooltip dinamicamente

    if (allFilesUploaded) {
      submitButton.removeAttr('title');
      $('#submit').prop('disabled', !allFilesUploaded).css({
        opacity: '1',
        cursor: 'pointer',
      });
    } else {
      submitButton.attr(
        'title',
        'Envie todos os arquivos necessários para desbloquear este botão.'
      );
    }
  });

  

  // Verifica se todos os ficheiros estão carregados
  function checkAllFileInputs() {
    let allUploaded = true;
    form.find('.uploadFileLes').each(function () {
      let extension = getFileExtension($(this).val());
      if (!$(this).val() || extension == '.docx') {
        allUploaded = false;
        return false;
      }
    });
    return allUploaded;
  }
});


function getFileExtension(fileName) {
  const fileExtIndex = fileName.lastIndexOf('.');

  const fileExtension =
    fileExtIndex !== -1 ? fileName.substring(fileExtIndex) : '';

    return fileExtension;
}

jQuery(document).ready(function ($) {
  // Atualizar o modal após alterar o carrinho
  $(document.body).on('updated_wc_div', function () {
    refreshCheckoutModal();
  });

  function refreshCheckoutModal() {
    $.ajax({
      url: wc_cart_fragments_params.ajax_url,
      type: 'POST',
      data: { action: 'update_checkout_modal' },
      success: function (response) {
        if (
          $('#checkoutModal .checkout-modal-content .form-row-container').length
        ) {
          $('#checkoutModal .checkout-modal-content .form-row-container').html(
            response
          );
        } else {
          $('#checkoutModal .checkout-modal-content').append(
            '<div class="form-row-container">' + response + '</div>'
          );
        }
      },
      error: function (error) {
        console.error('Erro ao atualizar o modal:', error);
      },
    });
  }
});

jQuery(document).ready(function($) {
  if (window.location.pathname.includes('/order-received/')) {
      
      setTimeout(function() {
          var orderId = window.location.pathname.match(/\/(\d+)\//)[1] || 'unknown';
          
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
              event: 'checkout_final_confirmation',
              order_id: orderId,
          });

      }, 3000);
  }
});


// WEBPACK FOOTER //
// ./scripts/routes/common.js